import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "multivendor"
    }}>{`MultiVendor`}</h1>
    <p>{`In this chapter we are going to point out with screenshots about the multivendor flow of Pixer application. So that you can understand the view of the application.`}</p>
    <h2 {...{
      "id": "create-new-shop"
    }}>{`Create New Shop`}</h2>
    <p>{`To create new shop login as an `}<inlineCode parentName="p">{`administrator`}</inlineCode>{` or create a new vendor account for creating `}<inlineCode parentName="p">{`shop`}</inlineCode></p>
    <p><img alt="RegisterNewAccount.png" src={require("../images/RegisterNewAccount.png")} /></p>
    <p><img alt="AccountInfo.png" src={require("../images/AccountInfo.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`After creating the account you'll be redirected to this page,`}</p>
    </blockquote>
    <p><img alt="Vendor.png" src={require("../images/Vendor.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`After that, click `}<inlineCode parentName="p">{`Create Shop`}</inlineCode>{`, and provide all the information for the `}<inlineCode parentName="p">{`store`}</inlineCode>{`.`}</p>
    </blockquote>
    <p><img alt="CreateShop.png" src={require("../images/CreateShop.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`After creating the shop you'll redirect to this page,`}</p>
    </blockquote>
    <p><img alt="CreatedShop.png" src={require("../images/CreatedShop.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`By default, the shop will be inactive. Only an `}<inlineCode parentName="p">{`administrator`}</inlineCode>{` can active a shop from Super Admin dashboard.`}</p>
    </blockquote>
    <p><img alt="ActivateShop.png" src={require("../images/ActivateShop.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`After click on `}<inlineCode parentName="p">{`shop`}</inlineCode>{`, you'll be redirected to dashboard page,`}</p>
    </blockquote>
    <p><img alt="CreatedShop.png" src={require("../images/ShopDashboard.png")} /></p>
    <p>{`From this dashboard, you can maintain the shop,`}</p>
    <h2 {...{
      "id": "user-role--super-admin"
    }}>{`User Role : Super Admin`}</h2>
    <p>{`In a multi-vendor e-commerce platform, the super admin embodies supreme control, overseeing the entire ecosystem. Armed with unparalleled authority, they manage vendors, uphold platform integrity, regulate operations, and ensure a seamless experience for buyers and sellers, pivotal in steering the platform's success and sustained growth.`}</p>
    <h2 {...{
      "id": "user-role--store-owner-or-vendor"
    }}>{`User Role : Store Owner or Vendor`}</h2>
    <p>{`In a multi-vendor e-commerce platform, a vendor represents an independent seller or entity offering diverse products or services. Vendors operate individual storefronts within the marketplace, showcasing their unique offerings. They manage inventory, sales, and fulfillment, contributing to the platform's varied and extensive product catalog, fostering competition and consumer choice.`}</p>
    <h2 {...{
      "id": "user-role--staff"
    }}>{`User Role : Staff`}</h2>
    <p>{`In a multi-vendor e-commerce platform, shop staff are pivotal intermediaries, managing vendor interactions, ensuring seamless operations, and fostering vendor relations. They oversee onboarding, resolve orders & disputes, optimize product listings, and provide ongoing support, crucially upholding quality standards while nurturing a collaborative environment to enhance the platform's marketplace experience.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      